import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#6B0000] to-[#4A0000]">
        <div className="max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
            Legal
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6">
            Privacy Policy
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 space-y-8">
            {/* Introduction */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Introduction
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                On Target Prints ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our custom apparel design services.
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                By using our website, you agree to the collection and use of information in accordance with this policy.
              </p>
            </div>

            {/* Information We Collect */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Information We Collect
              </h2>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Personal Information
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                We may collect personal information that you voluntarily provide to us when you:
              </p>
              <ul className="space-y-2 text-sm text-gray-600 mb-4">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Place an order or create a custom design</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Create an account on our website</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Subscribe to our newsletter</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Contact us with questions or feedback</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                This information may include: name, email address, phone number, shipping address, billing address, and payment information.
              </p>

              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Design and Upload Data
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                When you use our design studio, we collect the custom designs, text, and images you create or upload. This data is used solely to fulfill your order and is not shared with third parties.
              </p>

              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Automatically Collected Information
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We automatically collect certain information when you visit our website, including IP address, browser type, device information, pages visited, and time spent on pages. This helps us improve our website and services.
              </p>
            </div>

            {/* How We Use Your Information */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                How We Use Your Information
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                We use the information we collect to:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Process and fulfill your custom apparel orders</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Communicate with you about your orders and account</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Send promotional emails and newsletters (with your consent)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Improve our website, products, and services</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Prevent fraud and enhance security</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Comply with legal obligations</span>
                </li>
              </ul>
            </div>

            {/* Information Sharing */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Information Sharing and Disclosure
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span><strong className="text-gray-900">Service Providers:</strong> Third-party vendors who help us operate our business (payment processors, shipping carriers, email services)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span><strong className="text-gray-900">Legal Requirements:</strong> When required by law or to protect our rights and safety</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span><strong className="text-gray-900">Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</span>
                </li>
              </ul>
            </div>

            {/* Data Security */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Data Security
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            {/* Your Rights */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Your Privacy Rights
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                You have the right to:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Access and review your personal information</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Request correction of inaccurate information</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Request deletion of your personal information</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Opt-out of marketing communications</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 leading-relaxed mt-4">
                To exercise these rights, contact us at <a href="mailto:hello@ontargetprints.com" className="font-bold text-[#6B0000] hover:underline cursor-pointer">hello@ontargetprints.com</a>.
              </p>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Cookies and Tracking Technologies
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, and personalize content. You can control cookie preferences through your browser settings.
              </p>
            </div>

            {/* Children's Privacy */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Children's Privacy
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child, please contact us immediately.
              </p>
            </div>

            {/* Changes */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Changes to This Privacy Policy
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </div>

            {/* Contact */}
            <div className="bg-red-50 rounded-lg p-6 border border-red-100">
              <h2 className="text-xl font-black text-gray-900 mb-3">
                Contact Us
              </h2>
              <p className="text-sm text-gray-600 mb-3">
                If you have questions about this Privacy Policy, please contact us:
              </p>
              <div className="space-y-1 text-sm text-gray-900">
                <p><strong>Email:</strong> <a href="mailto:hello@ontargetprints.com" className="text-[#6B0000] hover:underline cursor-pointer">hello@ontargetprints.com</a></p>
                <p><strong>Address:</strong> 123 Main Street, Starkville, MS 39759</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}